import { TournamentType } from "../pages/tournament/hook/useEditTournament";

export function isGTDType(type?: TournamentType) {
  if (!type) return false;
  if (type === TournamentType.Tournament) return true;
  return false;
}

export function isDailyType(type?: TournamentType) {
  if (!type) return false;
  if (type === TournamentType.Daily) return true;
  return false;
}

export function isEventType(type?: TournamentType) {
  if (!type) return false;
  if (type === TournamentType.Milestone) return true;
  return false;
}

export function getTournamentTypeName(type: TournamentType) {
  switch (type) {
    case TournamentType.Tournament:
      return "GTD";
    case TournamentType.Daily:
      return "데일리";
    case TournamentType.Milestone:
      return "이벤트";
    case TournamentType.TimeAttack:
      return "타임어택";
  }
}
